//@flow
import prescreeningQuiz from './questions/prescreening'
import category1_1 from './questions/cat1.1'
import category1_2 from './questions/cat1.2'
import category1_3 from './questions/cat1.3'
import category2_1 from './questions/cat2.1'
import category2_2 from './questions/cat2.2'
import category2_3 from './questions/cat2.3'
import category2_4 from './questions/cat2.4'
import category2_5 from './questions/cat2.5'
import category2_6 from './questions/cat2.6'
import category3_1 from './questions/cat3.1'
import category3_2 from './questions/cat3.2'
import category3_3 from './questions/cat3.3'
import category3_4 from './questions/cat3.4'
import category4_1 from './questions/cat4.1'
import category4_2 from './questions/cat4.2'
import category4_3 from './questions/cat4.3'
import category4_4 from './questions/cat4.4'
import category5_1 from './questions/cat5.1'
import category5_2 from './questions/cat5.2'
import category5_3 from './questions/cat5.3'
import category5_4 from './questions/cat5.4'

export const dpQuestions = {
  ...prescreeningQuiz,
  ...category1_1,
  ...category1_2,
  ...category1_3,
  ...category2_1,
  ...category2_2,
  ...category2_3,
  ...category2_4,
  ...category2_5,
  ...category2_6,
  ...category3_1,
  ...category3_2,
  ...category3_3,
  ...category3_4,
  ...category4_1,
  ...category4_2,
  ...category4_3,
  ...category4_4,
  ...category5_1,
  ...category5_2,
  ...category5_3,
  ...category5_4,
}

export const dpQuestionCategories = {
  '1_1': getCategoryQuestions(category1_1),
  '1_2': getCategoryQuestions(category1_2),
  '1_3': getCategoryQuestions(category1_3),
  '2_1': getCategoryQuestions(category2_1),
  '2_2': getCategoryQuestions(category2_2),
  '2_3': getCategoryQuestions(category2_3),
  '2_4': getCategoryQuestions(category2_4),
  '2_5': getCategoryQuestions(category2_5),
  '2_6': getCategoryQuestions(category2_6),
  '3_1': getCategoryQuestions(category3_1),
  '3_2': getCategoryQuestions(category3_2),
  '3_3': getCategoryQuestions(category3_3),
  '3_4': getCategoryQuestions(category3_4),
  '4_1': getCategoryQuestions(category4_1),
  '4_2': getCategoryQuestions(category4_2),
  '4_3': getCategoryQuestions(category4_3),
  '4_4': getCategoryQuestions(category4_4),
  '5_1': getCategoryQuestions(category5_1),
  '5_2': getCategoryQuestions(category5_2),
  '5_3': getCategoryQuestions(category5_3),
  '5_4': getCategoryQuestions(category5_4),
}

export const dpPercentageComputation = {
  "1": {
    "1": [
      {from: 0, to: 20, score: 0},
      {from: 21, to: 59, score: 1},
      {from: 60, to: 99, score: 2},
      {from: 100, to: 100, skip: "next"}
    ],
    "3": [
      {from: 0, to: 20, score: 2},
      {from: 21, to: 59, score: 3},
      {from: 60, to: 99, score: 4},
      {from: 100, to: 100, skip: "next" }
    ],
    "5": [
      {from: 0, to: 20, score: 4},
      {from: 21, to: 59, score: 5},
      {from: 60, to: 99, score: 6},
      {from: 100, to: 100, skip: "next"}
    ],
    "7": [
      {from: 0, to: 20, score: 6},
      {from: 21, to: 80, score: 7},
      {from: 81, to: 100, score: 8 }
    ]
  },
  "3": {
    "1": [
      {from: 0, to: 20, score: 0},
      {from: 21, to: 59, score: 1},
      {from: 60, to: 100, score: 2}
    ],
    "3": [
      {from: 0, to: 20, skip: "previous"},
      {from: 21, to: 59, score: 3},
      {from: 60, to: 99, score: 4},
      {from: 100, to: 100, skip: "next"}
    ],
    "5": [
      {from: 0, to: 20, score: 4},
      {from: 21, to: 59, score: 5},
      {from: 60, to: 99, score: 6},
      {from: 100, to: 100, skip: "next"}
    ],
    "7": [
      {from: 0, to: 20, score: 6},
      {from: 21, to: 80, score: 7},
      {from: 81, to: 100, score: 8 }
    ]
  },

  "5": {
    "1": [
      {from: 0, to: 20, score: 0},
      {from: 21, to: 59, score: 1},
      {from: 60, to: 100, score: 2}
    ],
    "3": [
      {from: 0, to: 20, skip: "previous"},
      {from: 21, to: 59, score: 3},
      {from: 60, to: 100, score: 4}
    ],
    "5": [
      {from: 0, to: 20, skip: "previous"},
      {from: 21, to: 59, score: 5},
      {from: 60, to: 99, score: 6},
      {from: 100, to: 100, skip: "next"}
    ],
    "7": [
      {from: 0, to: 20, score: 6},
      {from: 21, to: 80, score: 7},
      {from: 81, to: 100, score: 8 }
    ]
  },

  "7": {
    "1": [
      {from: 0, to: 20, score: 0},
      {from: 21, to: 59, score: 1},
      {from: 60, to: 100, score: 2}
    ],
    "3": [
      {from: 0, to: 20, skip: "previous"},
      {from: 21, to: 59, score: 3},
      {from: 60, to: 100, score: 4}
    ],
    "5": [
      {from: 0, to: 20, skip: "previous"},
      {from: 21, to: 59, score: 5},
      {from: 60, to: 100, score: 6}
    ],
    "7": [
      {from: 0, to: 34, skip: "previous"},
      {from: 35, to: 60, score: 7},
      {from: 61, to: 100, score: 8 }
    ]
  }
}

/**
 * format the questions and map to levels
 */
function getCategoryQuestions(questions) {
  const data = {
    "1": [],
    "3": [],
    "5": [],
    "7": []
  }
  Object.keys(questions).forEach(d => {
    const level = d.split("l")[1].charAt(0)
    data[level].push(d)
  })
  
  return data;
}

export const categoryTitles = {
  "1_1": "Browsing, searching and filtering information",
  "1_2": "Evaluating Information",
  "1_3": "Managing Information",
  "2_1": "Interacting through and with digital technologies",
  "2_2": "Sharing Through Digital Technologies",
  "2_3": "Engaging in Citizenship through Digital Technologies",
  "2_4": "Collaborating through Digital Technologies",
  "2_5": "Digital behaviour",
  "2_6": "Managing Digital Identity",
  "3_1": "Developing digital content",
  "3_2": "Integrating and re-elaborating digital content",
  "3_3": "Copyright and licences",
  "3_4": "Computational Thinking and Programming",
  "4_1": "Protecting Devices",
  "4_2": "Protecting personal data and privacy",
  "4_3": "Supporting Wellbeing",
  "4_4": "Environmental Impacts of Digital Technologies",
  "5_1": "Identifying and solving technical problems",
  "5_2": "Identifying needs and digital technological responses",
  "5_3": "Identifying creative solutions using digital technologies",
  "5_4": "Identifying and addressing digital competence needs",
}

/**
 * Add here all possible assessment version to reset
 * This will ensure to display the right DigComp Version
 */
export const resetAssessmentVersions = [
  'digcomp2.2'
]



// WEBPACK FOOTER //
// ./src/constants/dp/index.js